import { Button, Drawer, Form, InputNumber, Select, Input, message } from "antd"
import React, { useState } from "react"
import { addDoc, collection, serverTimestamp } from "firebase/firestore"
import { db } from "../../../firebase/config"

export default function CreateRoll({ materialData, materialLoading }) {
  const [open, setOpen] = useState(false)
  const [selectedMaterial, setSelectedMaterial] = useState()
  const [form] = Form.useForm()

  const showDrawer = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
  }

  //when a form finishes
  const onFinish = (values) => {
    const { rolls, ...materialWithoutRolls } = selectedMaterial

    const data = {
      ...values,
      comment: values.comment || "", // Set the comment field to an empty string if it's not set explicitly in the form
    }
    const newData = {
      ...data,
      inUse: false,
      material: materialWithoutRolls,
      created: serverTimestamp(),
      updated: serverTimestamp(),
      originalMeters: data.remainingMeters,
    }

    addNewRoll(newData)
  }
  //if form failed
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo)
  }

  const handleMaterialChange = (value, object) => {
    setSelectedMaterial(object)
    console.log(object)
  }

  //adds the roll
  const addNewRoll = async (data) => {
    const updateRef = collection(db, "rolls")
    let newData = {
      ...data,
      rollLocation: 0,
      created: serverTimestamp(),
      updated: serverTimestamp(),
    }
    try {
      await addDoc(updateRef, newData) // Use await to ensure that the document is added before resetting the form fields
      message.success(`Success! Roll has been created.`)
      setOpen(false)
      form.resetFields() // Reset form fields after the data is successfully added
    } catch (error) {
      message.error(error)
    }
  }
  return (
    <>
      <Button onClick={showDrawer}>Create Roll</Button>
      <Drawer title="Add roll" placement="right" onClose={onClose} open={open} width={500}>
        <Form
          form={form}
          name="basic"
          onFinish={onFinish}
          layout="vertical"
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          style={{ width: "100%" }}>
          <Form.Item
            label="Material"
            name="selectedMaterialID"
            rules={[
              {
                required: true,
                message: "Please input Meters",
              },
            ]}>
            <Select
              placeholder="Select status"
              optionFilterProp="children"
              onChange={handleMaterialChange}
              fieldNames={{ label: "material", value: "id" }}
              loading={materialLoading}
              filterOption={(input, option) =>
                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
              options={materialData && materialData}
            />
          </Form.Item>

          <Form.Item
            label="Meters"
            name="remainingMeters"
            rules={[
              {
                required: true,
                message: "Please input Meters",
              },
            ]}>
            <InputNumber
              style={{ width: "100%" }}
              placeholder="Enter the amount of meters inside Material roll"
            />
          </Form.Item>

          <Form.Item
            label="Width"
            name="rollWidth"
            rules={[
              {
                required: true,
                message: "Please input Meters",
              },
            ]}>
            <InputNumber style={{ width: "100%" }} placeholder="Enter width of the roll" />
          </Form.Item>

          <Form.Item
            label="Status of the roll"
            name="ordered"
            rules={[
              {
                required: true,
                message: "Please input Meters",
              },
            ]}>
            <Select
              showSearch
              placeholder="Select roll status"
              options={[
                {
                  value: true,
                  label: "In Order",
                },
                {
                  value: false,
                  label: "Stock",
                },
              ]}
            />
          </Form.Item>

          <Form.Item name="comment" label="Comment">
            <Input.TextArea name="comment" rows={2} placeholder="Roll comment" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Add Roll
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  )
}
